import React, { Component } from 'react';
import quizQuestions from 'react/app/api/quizQuestions';
import Quiz from 'react/app/Components/Quiz';
import Result from 'react/app/Components/Result';
// import logo from './svg/logo.svg' ;

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            counter: 0,
            questionId: 1,
            question: '',
            options: [],
            answer: 0,
            answersCount: 0,
            correct: '',
            result: ''
        };

        this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
    }

    componentWillMount() {
        const shuffledAnswerOptions = quizQuestions.map((question) => this.shuffleArray(question.answers));
        this.setState({
            question: quizQuestions[0].question,
            options: shuffledAnswerOptions[0],
            answer: 0,
            correct: quizQuestions[0].answer.option.id
        });
    }

    shuffleArray(array) {
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    };

    handleAnswerSelected(event) {
        this.setUserAnswer(event, event.currentTarget.value);

        if (this.state.questionId < quizQuestions.length) {
            setTimeout(() => this.setNextQuestion(), 1600);
        } else {
            setTimeout(() => this.setResults(this.getResults()), 1600);
        }
    }

    setUserAnswer(event, answer) {

        answer = parseInt(answer, 10);
        if (answer === this.state.correct) {
            event.target.parentNode.className = "btn btn-success waves-effect w-md btn-lg btn-block ";
            var updatedAnswersCount = this.state.answersCount + 1;
            this.setState({
                answersCount: updatedAnswersCount,
                answer: answer
            });

        } else {
            event.target.parentNode.className = "btn btn-warning waves-effect w-md btn-lg btn-block ";
            this.setState({
                answer: answer
            });
        }


    }

    setNextQuestion() {
        const counter = this.state.counter + 1;
        const questionId = this.state.questionId + 1;

        this.setState({
            counter: counter,
            questionId: questionId,
            question: quizQuestions[counter].question,
            options: quizQuestions[counter].answers,
            answer: 0,
            correct: quizQuestions[counter].answer.option.id
        });
    }

    getResults() {
        var answersCount = this.state.answersCount;

        return answersCount;
    }

    setResults(result) {
        if (result) {
            this.setState({
                result: result
            });
        } else {
            this.setState({
                result: 0
            });
        }

    }

    renderQuiz() {
        return (
            <div>
                <div className="col-lg-3 col-md-6">
                    <div className="card-box widget-box-two widget-two-primary">
                        <i className="mdi mdi-check widget-two-icon"></i>
                        <div className="wigdet-two-content text-white">
                            <p className="m-0 text-uppercase font-600 font-secondary text-overflow" title="Statistics">Score</p>
                            <h2 className="text-white"><span data-plugin="counterup">{this.state.answersCount} /{quizQuestions.length}</span></h2>
                            <p className="m-0">--------</p>
                        </div>
                    </div>
                </div>

                <Quiz
                    answer={this.state.answer}
                    options={this.state.options}
                    answerCount = {this.state.answersCount}
                    questionId={this.state.questionId}
                    question={this.state.question}
                    questionTotal={quizQuestions.length}
                    onAnswerSelected={this.handleAnswerSelected}
                />
            </div>

            );
    }

    renderResult() {
        return (
            <Result quizResult={this.state.result} />
            );
    }

    render() {
        return (
            <div className="App">
      
                {this.state.result ? this.renderResult() : this.renderQuiz()}
            </div>
            );
    }

}

export default App;



// WEBPACK FOOTER //
// ./react/app/components/App.js